import {
    Button, Dialog, DialogActions, DialogContent,
    DialogTitle, IconButton, Typography,
} from "@mui/material";
import {Close} from "@mui/icons-material";
import {useTranslation} from "react-i18next";

interface ActivateVersionDialogProps {
    open: boolean;
    versionNumber: number | null;
    onClose: () => void;
    onConfirm: () => void;
    loading?: boolean;
}

const ActivateVersionDialog = ({open, versionNumber, onClose, onConfirm, loading}: ActivateVersionDialogProps) => {
    const {t} = useTranslation("templates");
    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle sx={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                {t('activateDialog.title')}
                <IconButton size="small" onClick={onClose}><Close/></IconButton>
            </DialogTitle>
            <DialogContent>
                <Typography variant="body2">
                    {t('activateDialog.question')}
                </Typography>
            </DialogContent>
            <DialogActions sx={{px: 3, pb: 2}}>
                <Button variant="outlined" onClick={onClose}>{t('activateDialog.cancel')}</Button>
                <Button variant="contained" color="accent" onClick={onConfirm} disabled={loading}>
                    {loading ? t('activateDialog.loading') : t('activateDialog.confirm')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ActivateVersionDialog;
